module.exports = __webpack_public_path__ + "img/tb_t305-91-11.prt.5d2c2a9b.jpg";